export default {
  issueDetail: {
    title: '发放明细',
    qrCode: '二维码',
    qrCodePlaceholder: '请输入二维码',
    productInfo: '商品信息',
    productInfoPlaceholder: '请输入关键词搜索',
    relatedInfo: '关联信息',
    relatedInfoPlaceholder: '请输入关键词搜索',
    memberInfo: '会员信息',
    memberInfoPlaceholder: '会员信息',
    issueTime: '发放时间',
    country: '国家',
    issuePoints: '发放积分',
    spec: '规格',
    singleSpec: '单规格',
    memberId: '会员ID',
    direction: '方向',
    directionAdd: '增加',
    directionSubtract: '扣减',
    directionFreeze: '冻结',
    directionUnfreeze: '解冻',
    points: '积分',
    beforePoints: '变动前',
    afterPoints: '变动后',
    sourceType: '来源类型',
    sourceTypeScan: '扫码',
    sourceTypeActivity: '活动',
    sourceTypeManual: '手动',
    sourceTypeMall: '商城',
    sourceTypeRedPacket: '红包',
    sourceName: '来源名称',
    remark: '备注',
    timeRequired: '请选择发放时间',
  },
  issueStats: {
    title: '发放统计',
    date: '日期',
    totalIssued: '总发放数据',
    totalConsumed: '总消耗数据',
    chartTitle: '近7天积分发放情况',
    rankTitle: '积分发放商品排行',
    rankNo: '排名',
    productDetail: '商品详情',
    totalPoints: '总发放积分',
    spec: '规格',
    singleSpec: '单规格',
  },
  config: {
    title: '基础配置/积分规则',
    language: '语言',
    addLang: '添加多语言',
    deleteLang: '删除多语言',
    deleteLangConfirm: '确认删除当前语言配置？',
    ruleTitle: '标题',
    content: '内容',
    addLangModalTitle: '添加多语言',
    languagePlaceholder: '请选择语言',
  },
};
